<template>
    <div component="Admin" template="page">
        <div class="bg">
            <div
                container="main"
                type="vertical"
                align="stretch"
                valign="top"
                padding="0"
                state="edit-"
                v-if="!loading && !fatalError"
            >
                <admin-header />

                <v-row block="body">
                    <transition name="zoomIn">
                        <router-view view="detail"></router-view>
                    </transition>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AdminHeader from '@/components/Admin/AdminHeader.vue';

export default {
    name: 'Admin',

    data() {
        return {
            fatalError: false,
            loading: true,
            email: null,
        };
    },

    async created() {},

    async mounted() {
        this.loading = false;
    },

    methods: {
        ...mapActions({}),

        hasHistory() {
            return window.history.length > 2;
        },
    },

    computed: {
        ...mapGetters({}),
    },

    components: {
        AdminHeader,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

.v-snack__content {
    text-align: center !important;

    * {
        color: inherit;
    }

    h3 {
        color: @primary_dk;
    }
}
[component='Admin'] {
    .bg {
        max-width: inherit;
    }
    [container='main'] {
        max-width: 100%;
        display: flex;
        flex-direction: row;
    }
}

[component='Admin'] {
    height: 100vh;
    max-height: 100vh;

    [container='main'] {
        position: inherit;
        max-width: 100%;

        & > .row {
            flex: 0 1 auto;
        }

        & > .row ~ .row {
            flex: 1 1 auto;
        }
    }

    .project-detail-header {
        h3 {
            font-weight: 500;
        }
        & > .col {
            align-items: center;
        }
    }

    .project-navigation {
        .approved-btn {
            background-color: #4caf50 !important;
            border-color: #4caf50 !important;
        }
        .v-btn {
            background: none;
            color: initial;
        }
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    .container {
        display: flex;
        flex-direction: row;
    }

    .v-input {
        input {
            border: none !important;
        }
    }
}

[component='Admin'] [block='body'] {
    transition: 0.5s;
    transition-delay: 0s;
    position: absolute;
    width: 100%;
    z-index: 50;
    margin-top: calc(100vw + 60px);
    height: 200px;

    @media (max-height: 620px) {
        margin-top: calc(100vw + 0px);
    }

    @media (min-width: 769px) {
        position: relative;
        height: 100%;
        width: 75%;
        margin-top: 0px;
    }

    @media (min-width: 980px) {
        background: linear-gradient(120deg, transparent 60%, #eaeaea);
        border-radius: 0px 20px 20px 0;
    }
}
</style>
